module.exports = __webpack_public_path__ + "static/media/banner_MyAccount.ea904bfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background/banner_MyAccount.png
// module id = 5897
// module chunks = 0